import { Stack } from "@mui/material";

export default function ReportToolbar({ children }) {
  return (
    <Stack
      direction={{
        xs: "column",
        md: "row",
      }}
      spacing={2}
      justifyContent="space-between"
      alignItems={{
        xs: "stretch",
        md: "center",
      }}
      sx={{
        mb: 3,
      }}
    >
      {children}
    </Stack>
  );
}